import { Tag } from 'antd';
import React from 'react';

export function BillingStatus(status) {
  const color = status === 'PAID' ? 'green' : (status === 'UNPAID' ? 'warning' : 'error');
  return <Tag color={color}>{status}</Tag>;
}
